import { observer } from "mobx-react";

import Icon from "components/UI/IconSVG/Icon";
import { BudgetSlider } from "components/BudgetSlider/BudgetSlider";
import Equipment from "../../Equipment/Equipment";
import Faqed from "components/UI/Faqed/Faqed";
import CheckBox from "components/UI/CheckBox/CheckBox";

import "./BotsCalculator.scss";

/**
 * Цену считает сервер: пока её нет, показываем это честно, а не ноль рублей.
 */
function getPriceText(calculator, price) {
  if (calculator.priceError)
    return 'цена недоступна';
  if (calculator.isPriceLoading && !price)
    return '…';
  return `${price.toLocaleString()} ₽`;
}

const BotsCalculator = observer(({ store, modeBots, currentCalculatorPrice, isTestPackageSelected }) => {
  const testing = store.testing;

  // Аренда фермы приходит с сервера отдельной строкой разбивки и равна нулю,
  // когда выбран общий сервер, поэтому складываем без условия.
  const serverPrice = store.currentCalculator.serverPrice ?? 0;

  const totalSum = isTestPackageSelected
    ? currentCalculatorPrice
    : (currentCalculatorPrice + serverPrice);

  return (
    <div className="bots-calculator">
      <div className="bots-calculator__container">
        <div className="bots-calculator__container-top">
          <div className="bots-calculator__info">
            <p className="bots-calculator__info-text">Стоимость ботов</p>
            <p className="bots-calculator__info-sum">{testing ? 'ТЕСТ' : getPriceText(store.currentCalculator, currentCalculatorPrice)}</p>
          </div>

          {!isTestPackageSelected && store.isBotFarm &&
            <p className="bots-calculator__price-equipment">
              + аренда оборудования <span>{serverPrice.toLocaleString() + '\u00a0₽'}</span>
            </p>
          }
        </div>

        <div className="bots-calculator__budget" style={testing ? { visibility: 'hidden' } : {}}>
          <BudgetSlider store={store} modeBots={modeBots} disabled={testing}>
            <Icon className="bots-calculator__budget-icon" sprite="another" name="bot-budget" />
            <p>{testing ? '' : `≈ ${store.currentCalculator.chainsCount.toLocaleString()}`}</p>
          </BudgetSlider>
        </div>
      </div>

      <div className="bots-calculator__checked">
        <Faqed text="Система, которая автоматически создает и управляет ботами, адаптированными под ваши интересы. Боты могут собирать информацию, публиковать контент, взаимодействовать с подписчиками и выполнять другие задачи, экономя ваше время">
          <CheckBox title="Персонализация с учетом краткосрочных и долгосрочных интересов по Метрике" checked={store.isBotFarm} onClick={() => store.setIsBotFarm(!store.isBotFarm)} />
        </Faqed>
      </div>

      <div className="bots-calculator__container">
        {store.isBotFarm && !isTestPackageSelected && <Equipment />}
        <div className="bots-calculator__price-total">
          <p>Итого:</p>
          <p>{testing ? 'ТЕСТ' : getPriceText(store.currentCalculator, totalSum)}</p>
        </div>
      </div>
    </div>
  );
});

export default BotsCalculator;
